/*eslint-disable*/
export const messages = {
  // System notices (truncation / safety refusal)
  "This answer was shortened because it reached the length limit and may be incomplete.": "Esta respuesta se acortó porque alcanzó el límite de longitud y puede estar incompleta.",
  "This request can't be answered due to safety guidelines. Please rephrase or ask about a different topic.": "Esta solicitud no se puede responder debido a las directrices de seguridad. Reformúlela o pregunte sobre otro tema.",
  "Cancel": "Cancelar",
  "Change theme": "Cambiar tema",
  "Clear chat": "Borrar chat",
  "Clear chat history": "Borrar historial de chat",
  "Connecting...": "Conectando...",
  "Continue": "Continuar",
  "Decrease font size": "Disminuir tamaño de fuente",
  "Disclaimer": "Aviso legal",
  "Enter your message...": "Escribe tu mensaje...",
  "Type your message...": "Escribe tu mensaje...",
  "Error": "Error",
  "Font size": "Tamaño de fuente",
  "Increase font size": "Aumentar tamaño de fuente",
  "Language": "Idioma",
  "MJ Lab": "Laboratorio MJ",
  "Reset font size": "Restablecer tamaño de fuente",
  "Respond time: {time}s": "Tiempo de respuesta: {time}s",
  "Response time:": "Tiempo de respuesta:",
  "Send": "Enviar",
  "Settings": "Configuración",
  "Support the project": "Apoyar el proyecto",
  "System": "Sistema",
  "Theme": "Tema",
  "Thinking...": "Pensando...",
  "Toggle theme": "Alternar tema",
  "Welcome to Mila by MJ": "Bienvenido a Mila por MJ",
  "You asked:": "Preguntaste:",
  
  // Headers
  "Ministry of Commerce Laws Expert": "Experto en Leyes del MoC",
  "by MJ": "por MJ",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "Hola, soy {{name}}, un asistente de IA creado por MJ.",
  "I am expert in Ministry of Commerce laws and regulations for Saudi Arabia.": "Soy experto en leyes y regulaciones del Ministerio de Comercio de Arabia Saudita.",
  "Ask me a question, and I will gladly answer you.": "Hazme una pregunta y con gusto te responderé.",
  "Do not share confidential data.": "No compartas datos confidenciales.",
  "I am powered using": "Funciono utilizando",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi Ministry of Commerce laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**Aviso legal:** {{name}} es un asistente de IA experimental diseñado para responder utilizando datos de las leyes y regulaciones del Ministerio de Comercio de Arabia Saudita, evitando suposiciones o inexactitudes. No soy responsable de su comportamiento o la corrección de sus respuestas.",
  
  // Frameworks
  "Automatic detection": "Detección automática",
  
  // A. Business Formation and Identity
  "MOC_COMPANIES_LAW": "A1. Ley de Sociedades del MC",
  "MOC_PROFESSIONAL_COMPANIES_LAW": "A2. Ley de Sociedades Profesionales del MC",
  "MOC_COMMERCIAL_REGISTER_LAW": "A3. Ley del Registro Mercantil del MC",
  "MOC_MINISTRY_OF_COMMERCE_LAW": "A4. Ley del Ministerio de Comercio",
  "MOC_TRADE_NAMES_LAW": "A5. Ley de Nombres Comerciales del MC",
  "MOC_GCC_TRADEMARK_LAW": "A6. Ley de Marcas del CCG",
  
  // B. Financial Instruments, Security, and Insolvency
  "MOC_COMMERCIAL_PAPERS_LAW": "B1. Ley de Documentos Comerciales del MC",
  "MOC_COMMERCIAL_PLEDGE_LAW": "B2. Ley de Garantía Comercial del MC",
  "MOC_MOVABLE_PROPERTY_SECURITY_LAW": "B3. Ley de Garantía de Bienes Muebles del MC",
  "MOC_INSOLVENCY_LAW": "B4. Ley de Insolvencia del MC",
  
  // C. Commercial Relationships and Trade
  "MOC_COMMERCIAL_AGENCIES_LAW": "C1. Ley de Agencias Comerciales del MC",
  "MOC_FRANCHISE_LAW": "C2. Ley de Franquicias del MC",
  "MOC_ECOMMERCE_LAW": "C3. Ley de Comercio Electrónico del MC",
  "MOC_CHAMBERS_OF_COMMERCE_LAW": "C4. Ley de Cámaras de Comercio del MC",
  
  // D. Commercial Records and Information
  "MOC_COMMERCIAL_BOOKS_LAW": "D1. Ley de Libros Comerciales del MC",
  "MOC_COMMERCIAL_DATA_LAW": "D2. Ley de Datos Comerciales del MC",
  "MOC_PUBLIC_WAREHOUSING_LAW": "D3. Ley de Almacenamiento Público del MC",
  
  // E. Standards, Quality, and Regulated Products
  "MOC_STANDARDS_METROLOGY_LAW": "E1. Ley de Estándares y Metrología del MC",
  "MOC_CALIBRATION_MEASUREMENT_LAW": "E2. Ley de Calibración y Medición del MC",
  "MOC_PRIVATE_LABORATORIES_LAW": "E3. Ley de Laboratorios Privados del MC",
  "MOC_PRECIOUS_METALS_GEMSTONES_LAW": "E4. Ley de Metales Preciosos y Gemas del MC",
  "MOC_CHEMICALS_IMPORT_MANAGEMENT_LAW": "E5. Ley de Gestión de Importación de Químicos del MC",
  
  // F. Professional Regulation and Oversight
  "MOC_ACCOUNTING_AUDITING_LAW": "F1. Ley de Contabilidad y Auditoría del MC",
  "MOC_VALUERS_LAW": "F2. Ley de Tasadores del MC",
  "MOC_ENGINEERS_LAW": "F3. Ley de Ingenieros del MC",
  
  // G. Compliance and Dispute Resolution
  "MOC_ANTI_CONCEALMENT_LAW": "G1. Ley Anti-Ocultamiento del MC",
  "MOC_ANTI_MONEY_LAUNDERING_LAW": "G2. Ley Contra el Lavado de Dinero del MC",
  "MOC_ARBITRATION_LAW": "G3. Ley de Arbitraje del MC",
  "MOC_COMBATING_COMMERCIAL_ADULTERATION_LAW": "G4. Ley Contra la Adulteración Comercial del MC",
  "MOC_GCC_COMBATING_DUMPING_LAW": "G5. Ley Contra el Dumping del CCG",
  
  // Models
  "Claude by Anthropic": "Claude por Anthropic",
  "DeepSeek by Groq": "DeepSeek por Groq",
  "MJ Lab Mode": "Modo Laboratorio MJ",
  
  // Character count
  "{{remainingChars}} character left": "{{remainingChars}} carácter restante",
  "{{remainingChars}} characters left": "{{remainingChars}} caracteres restantes",
  
  // Error messages
  "An error occurred": "Ha ocurrido un error",
  "Failed to change language": "No se pudo cambiar el idioma",
  "Please try again": "Por favor, inténtalo de nuevo",
  "Connection lost": "Conexión perdida",
  "Reconnecting...": "Reconectando...",
  "Nothing to clear": "Nada que borrar",
  "All messages cleared": "Todos los mensajes borrados",
  "All data cleared": "Todos los datos borrados",
  "Storage limit reached": "Límite de almacenamiento alcanzado",
  "Some older messages were removed to save space.": "Algunos mensajes antiguos se eliminaron para ahorrar espacio.",
  
  // Additional keys
  "Font Size": "Tamaño de fuente",
  "Language changed to {{locale}}": "Idioma cambiado a {{locale}}",
  "Select language": "Seleccionar idioma",
  "Support": "Soporte",
  
  // Brand names (do not translate)
  "Mila": "Mila",
  
  // Message actions
  "Message copied to clipboard": "Mensaje copiado al portapapeles",
  "Read": "Leer",
  "Summarize": "Resumir",
  
  // Ice Breakers Dialog
  "Message Suggestions": "Sugerencias de mensajes",
  "Select a question to quickly start a conversation about Saudi Ministry of Commerce laws.": "Selecciona una pregunta para iniciar rápidamente una conversación sobre las leyes del Ministerio de Comercio de Arabia Saudita.",
  "What are the main requirements under the Companies Law for establishing a limited liability company in Saudi Arabia?": "¿Cuáles son los requisitos principales según la Ley de Sociedades para establecer una sociedad de responsabilidad limitada en Arabia Saudita?",
  "How does the Commercial Agencies Law regulate relationships between foreign companies and Saudi agents?": "¿Cómo regula la Ley de Agencias Comerciales las relaciones entre empresas extranjeras y agentes sauditas?",
  "What protections does the Saudi E-commerce Law provide for online consumers and businesses?": "¿Qué protecciones ofrece la Ley de Comercio Electrónico saudita para consumidores y empresas en línea?",
  
  // Audio Player Dialog
  "AI Summary": "Resumen de IA",
  "Listen to the summarized response using our AI Service.": "Escucha la respuesta resumida usando nuestro Servicio de IA.",
  "Generating summary...": "Generando resumen...",
  "Preparing audio...": "Preparando audio...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "Error al procesar texto. Por favor, inténtalo de nuevo.",
  "Failed to auto-play audio. Click play to try again.": "Error al reproducir audio automáticamente. Haz clic en reproducir para intentarlo de nuevo.",
  "Failed to load audio. Please try again.": "Error al cargar audio. Por favor, inténtalo de nuevo.",
  "Audio playback was aborted.": "La reproducción de audio fue interrumpida.",
  "Network error occurred while loading audio.": "Ocurrió un error de red al cargar el audio.",
  "Audio decoding failed.": "Falló la decodificación del audio.",
  "Audio format not supported.": "Formato de audio no compatible.",
  "Failed to setup audio playback": "Error al configurar la reproducción de audio",
  "Failed to generate speech": "Error al generar voz",
  "Failed to generate audio. Please try again.": "Error al generar audio. Por favor, inténtalo de nuevo.",
  "Failed to play audio. Please try again.": "Error al reproducir audio. Por favor, inténtalo de nuevo."
};